import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Separator } from '@radix-ui/react-dropdown-menu';

import { EditIcon } from '@/assets/icons';
import { Icon, Loader } from '@/components/atoms';
import { TRANSLATION_OVERVIEW_TEST_IDS } from '@/constants/data-testids';
import { LanguageNameMap } from '@/enums/languageCode';
import { TranslationCategory } from '@/types/management/managementCategories';

export type SetTranslationCaegoryOptions = Dispatch<SetStateAction<TranslationCategory[]>>;

type TranslationOverviewTranslationOverviewCategoryProps = {
  translationOptions: TranslationCategory[];
  className?: string;
  isLoading?: boolean;
  onEditClick: (option: TranslationCategory) => void;
};

export const TranslationOverviewCategory: FC<
  TranslationOverviewTranslationOverviewCategoryProps
> = ({ translationOptions, className, isLoading, onEditClick }) => {
  const { t } = useTranslation('components');

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={className}>
      {translationOptions.map((option, index) => (
        <div key={option.languageCode}>
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Icon name={option.languageCode} width={16} height={16} />
              <p className="grow">{LanguageNameMap[option.languageCode].name}</p>
              <EditIcon
                width={20}
                height={20}
                className="text-custom-warm-grey-400 cursor-pointer"
                onClick={() => onEditClick(option)}
                data-testid={TRANSLATION_OVERVIEW_TEST_IDS.EDIT_TRANSLATION_ICON}
              />
            </div>
            <div className="flex flex-col gap-3">
              <div>
                <p className="text-body-14-regular text-custom-warm-grey-500 mb-0.5">
                  {t('translationOverviewCategory.categoryNameText')}
                </p>
                <p className="text-body-14-regular text-custom-warm-grey-800"> {option.name}</p>
              </div>
              {option.description && (
                <div>
                  <p className="text-body-14-regular text-custom-warm-grey-500 mb-0.5">
                    {t('translationOverviewCategory.descriptionText')}
                  </p>
                  <p className="text-body-14-regular text-custom-warm-grey-800">
                    {option.description}
                  </p>
                </div>
              )}
            </div>

            {index !== translationOptions.length - 1 && (
              <Separator className="mt-5 h-[1px] bg-custom-warm-grey-200" />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
